"use client";

import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const scrolled = window.scrollY;
        parallaxRef.current.style.transform = `translateY(${scrolled * 0.3}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section ref={containerRef} className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div ref={parallaxRef} className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515703/img/custom_timber_frame_home_construction_maine_natural_environment.png)] bg-cover bg-center will-change-transform" style={{
      top: "-20%",
      height: "140%"
    }} />

      <div className="absolute inset-0 bg-dark-background/40" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <h1 className={`font-display text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 transition-all duration-[var(--duration-fast)] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          Build Your Custom Home with Confidence
        </h1>

        <p className={`text-lg md:text-xl lg:text-2xl text-white/90 mb-10 max-w-2xl mx-auto transition-all duration-[var(--duration-fast)] ease-out delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          Full custom home building in Central Maine, guided by direct communication,
          thoughtful decisions, and long-term performance.
        </p>

        <div className={`transition-all duration-[var(--duration-fast)] ease-out delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Link to="/ContactPage">
            <Button size="lg" className="text-base md:text-lg px-8 py-6 h-auto bg-primary-dark hover:bg-primary-dark text-foreground-primary font-semibold rounded-md shadow-medium hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-[1.02] active:scale-100">
              Start a Conversation
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}